export default __webpack_public_path__ + "static/onemobile-427d3539b5376fbd8bb461707f99d57c.svg";